/**
 * External dependencies
 */

import styled from 'styled-components';
import {
  NumericInput,
  Text,
  THEME_CONSTANTS,
} from '@web-stories-wp/design-system';

/**
 * Internal dependencies
 */

import { Row } from '../../../form';

export const PillRow = styled(Row)`
  align-items: flex-start;
  justify-content: space-between;
  button {
    flex: 1;
    z-index: 1;
  }
`;

export const FieldLabel = styled(Text).attrs({
  size: THEME_CONSTANTS.TYPOGRAPHY.PRESET_SIZES.SMALL,
})`
  color: ${({ theme }) => theme.colors.fg.primary};
  margin-bottom: 8px;
`;

export const Space = styled.div`
  flex: 0 0 20px;
`;

export const StyledNumericInput = styled(NumericInput)`
  flex-grow: 1;
`;
